import { extendTheme } from '@mui/joy/styles'

export const theme = extendTheme({
  fontFamily: {
    display: "'Inter', var(--joy-fontFamily-fallback)",
    body: "'Inter', var(--joy-fontFamily-fallback)",
  },
  components: {
    JoyButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
    JoyCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
}) 